<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <label for="Date">{{ $t("theDate") }} *</label>
        <v-text-field
          v-model="dateValue"
          prepend-inner-icon="event"
          :rules="[validationRules.required]"
          readonly
          v-bind="attrs"
          v-on="on"
          solo
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="dateValue"
        @input="menu = false"
        :min="nowDate"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";

export default {
  name: "groupDateComponent",
  mixins: [validationMixin],
  props: ["index"],
  data() {
    return {
      nowDate: new Date(Date.now()).toISOString().slice(0, 10),
      menu: false,
      dateValue: "",
    };
  },
  watch: {
    dateValue: {
      handler() {
        this.$emit("setDateValue", this.index, this.dateValue);
      },
    },
  },
};
</script>

<style></style>
